import { PERMISSIONS } from 'common/permissions';
/*
  These routes are subroutes of the specific organization which requires the orgId,
  in order to have that we do the template string in the connected drawer component
*/

export const PAGE_TITLES = {
  ATHLETE_ENROLLMENT: 'Athlete Enrollment',
  CURRENT_ACTIVITY: 'Current Activity',
  LOCATIONS: 'Locations',
  ORGANIZATION: 'Organization',
  PROFILE: 'My Profile',
  ANALYSIS: 'Data',
  SCALES: 'Scales',
  SPORTS_TEAMS: 'Sports & Teams',
  USERS: 'Users',
  LOGOUT: 'Logout',
  HELP: 'Help',
};

export const ORGANIZATIONS = {
  iconClass: 'fa-solid fa-sitemap',
  isOrgRoute: true,
  name: PAGE_TITLES.ORGANIZATION,
  route: '',
};

export const LOCATIONS = {
  iconClass: 'fa-solid fa-location-dot',
  isOrgRoute: true,
  name: PAGE_TITLES.LOCATIONS,
  route: '/locations',
  permission: PERMISSIONS.READ_LOCATIONS,
};

export const USERS = {
  iconClass: 'fa-solid fa-users',
  isOrgRoute: true,
  route: '/users',
  name: PAGE_TITLES.USERS,
  permission: PERMISSIONS.READ_USERS,
};

export const SCALES = {
  iconClass: 'fa-solid fa-weight-scale',
  isOrgRoute: true,
  name: PAGE_TITLES.SCALES,
  route: '/scales',
  permission: PERMISSIONS.READ_SCALES,
};

export const TEAMS = {
  iconClass: 'fa-solid fa-users-rectangle',
  isOrgRoute: true,
  name: PAGE_TITLES.SPORTS_TEAMS,
  route: '/teams',
};

export const ATHLETES = {
  iconClass: 'fas fa-running',
  isOrgRoute: true,
  name: PAGE_TITLES.ATHLETE_ENROLLMENT,
  route: '/athletes',
  permission: PERMISSIONS.READ_ATHLETES,
};

export const PROFILE = {
  iconClass: 'fa-solid fa-user',
  isOrgRoute: false,
  name: PAGE_TITLES.PROFILE,
  route: '/profile',
};

export const CURRENT_ACTIVITY = {
  iconClass: 'fa-solid fa-eye',
  isOrgRoute: true,
  name: PAGE_TITLES.CURRENT_ACTIVITY,
  route: '/currentSports',
};

export const ANALYSIS = {
  iconClass: 'fa-solid fa-chart-pie',
  isOrgRoute: true,
  name: PAGE_TITLES.ANALYSIS,
  route: '/reports',
};

export const LOGOUT = {
  iconClass: 'fa-solid fa-power-off',
  isOrgRoute: false,
  name: PAGE_TITLES.LOGOUT,
  route: '/logout', // route isn't used - but we need to make sure it doesn't show as active
};

export const HELP = {
  iconClass: 'far fa-question-circle',
  isOrgRoute: false,
  name: PAGE_TITLES.HELP,
  route: '/help', // route isn't used - but we need to make sure it doesn't show as active
};

export const DRAWER_ITEMS_TEAM_MANAGEMENT = [CURRENT_ACTIVITY, ATHLETES, TEAMS, ANALYSIS];

export const DRAWER_ITEMS_APP_MANAGEMENT = [ORGANIZATIONS, USERS, PROFILE];

export const DRAWER_ITEMS_SPORTSCALE_MANAGEMENT = [SCALES, LOCATIONS];
